import styled from 'styled-components';
import { Button } from 'library/components/button';

const StyledLayout = styled.section`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  > * {
    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }
`;

const StyledChildren = styled.div`
  flex-grow: 1;
  flex-basis: auto;
  overflow-y: auto;
  padding: 0.5em;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding-top: 1em;
  border-top: 1px #dfe3e4 solid;

  > * {
    margin-left: 1em;
  }
`;

const CancelButton = styled.button`
  background: #d7d7d7;
  color: #1e4c47;
  border: unset;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 1em;
  padding: 0.5em 1.5em;

  &&& :hover,
  :focus {
    background: ${(props) => props.theme.colors.yellow500};
    color: ${(props) => props.theme.colors.blue600};
    border: unset;
  }
`;

const SubmitButton = styled(Button)`
  color: #134a5e;
  background: #f0bd1d;
  border: unset;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 1em;
  padding: 0.5em 1.5em;

  &&& :hover,
  :focus {
    background: #c09717;
    color: #134a5e;
    border: unset;
  }
`;

export {
  StyledLayout,
  StyledChildren,
  StyledFooter,
  CancelButton,
  SubmitButton,
};
